/* eslint-disable @nx/enforce-module-boundaries */
'use client';

import { Card, Container } from '@mybridge/ui';
import { MyDisk } from 'v4/snippets/my-disk';
import { ProfileLayout } from 'v4/snippets/profile/layout';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { isMobile } from 'react-device-detect';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import { TeamsLayout } from 'v4/snippets/teams/layout/listing';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
const Disk = () => {
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const { t } = useTranslator();
  return (
    <AuthenticatedProviders>
      <Head>
          {/* <title>{loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''} {t('navigation.myDisk') || "myDisk"} | myBridge.me</title> */}
          <title>{loggedIn && globalNotifCount ? `(${globalNotifCount}) ` : ''}{t('navigation.myDisk') || "myDisk"} | myBridge.me</title>
        </Head>

      {isMobile ? (
        /* <TeamsLayout> */
        <TeamsLayout title={false}>
        <Card height="calc(100vh - 108px)">
          <MyDisk />
        </Card>
        {/* <Card height="auto">
          <MyDisk />
        </Card> */}
        </TeamsLayout>
      ) : ( 
        /* <TeamsLayout> */
        <TeamsLayout title={false}>
     
        <Container w="1320px" maxW="100%" height="calc(100vh - 70%)"  p={!isMobile ? ['5px 10px 0', 0] : [0, 2, 4]}>
          <Card h="100%" backgroundColor="white" borderRadius="0px" boxShadow="none" >
            <MyDisk />
          </Card>
        </Container>
        </TeamsLayout>
      )}
    </AuthenticatedProviders>
  );
};

export default Disk;
